import { render, staticRenderFns } from "./AppComplet.vue?vue&type=template&id=20628d30"
import script from "./AppComplet.vue?vue&type=script&lang=ts"
export * from "./AppComplet.vue?vue&type=script&lang=ts"
import style0 from "./AppComplet.vue?vue&type=style&index=0&id=20628d30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports